import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Every prompt entry hands off to one dedicated, durable conversation route.
export function useAIWorkspace() {
  const nav = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  return (prompt, options = {}) => {
    if (!prompt?.trim()) return;
    const id = crypto.randomUUID();
    const payload = { prompt: prompt.trim(), mode: options.mode || "Copilot", context: options.context || {}, preview_url: options.previewUrl || location.pathname };
    sessionStorage.setItem(`hs_ai_pending_${user.id}_${id}`, JSON.stringify(payload));
    if (window.self !== window.top) window.top.location.assign(`/copilot/${id}`);
    else nav(`/copilot/${id}`);
  };
}
